import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

// Initialize Firebase
const app = initializeApp(
  {
    apiKey: "AIzaSyCK0cH9ERs-sKyzne9mc8L5AKKpMYabCV4",
    authDomain: "fekra-c24e7.firebaseapp.com",
    databaseURL: "https://fekra-c24e7.firebaseio.com",
    projectId: "fekra-c24e7",
    storageBucket: "fekra-c24e7.appspot.com",
    messagingSenderId: "112883431514",
    appId: "1:112883431514:web:f2bafcd823195dfeaac063"
  }
)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const messaging = getMessaging(app);